module.exports = __webpack_public_path__ + "static/media/BAL.4bdb2f1b.svg";